import React, { useEffect, useState } from 'react';
import Data from '../../data';
import Util from '../../utils/Util';
import { useUspsBusinessAccount } from '.';

const { Carrier } = Data;

const IS_CARRIER_USPS_BUSINESS =
	Util.getQueryParamByName('carrier') === Carrier.USPSBusiness;

const useUspsBusiness = () => {
	const [shouldShowUspsBusiness, setShouldShowUspsBusiness] = useState(false);
	const {
		canConnectToUspsBusiness,
		isEligible,
		redirectUri,
		onboardingStatus,
		userInfoToken,
		isLoading,
		error,
		setError,
		refetch,
		clearUserInfoToken,
	} = useUspsBusinessAccount();

	const uspsBannerType =
		isEligible &&
		onboardingStatus?.EpsAccountNumber &&
		onboardingStatus?.Crid &&
		onboardingStatus?.ManifestMid
			? 'information'
			: 'warning';

	const showUspsBusiness = () => {
		setShouldShowUspsBusiness(true);
	};

	const hideUspsBusiness = () => {
		setShouldShowUspsBusiness(false);
	};

	useEffect(() => {
		setShouldShowUspsBusiness(isEligible && IS_CARRIER_USPS_BUSINESS);
	}, [isEligible]);

	return {
		canConnectToUspsBusiness,
		isEligible,
		redirectUri,
		onboardingStatus,
		userInfoToken,
		uspsBannerType,
		shouldShowUspsBusiness,
		isLoading,
		error,
		setError,
		refetch,
		showUspsBusiness,
		hideUspsBusiness,
		clearUserInfoToken,
	};
};

export default useUspsBusiness;
